export const CHECKOUT_DEFAULT_ERROR_DESCRIPTION = 'Please try again';
export const CHECKOUT_DEFAULT_ERROR_TITLE = "Sorry, there's been a problem";
export const CHECKOUT_DEFAULT_ERROR_ACTION = 'Try again';

export const DEFAULT_BUTTON_VALUE = 'OK';
export const CHOOSE_SLOT_BUTTON_VALUE = 'CHOOSE_SLOT';
